import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";

import styles from "./styles.scss";
import commonStyles from "components/Layout/Common/styles.scss";

import Header from "components/Layout/Header";
import Button from "components/Button";
import Modal01 from "components/Modal/Modal01";
import UploadLoading from "components/Loading/uploadLoading";

import { useDispatch, useSelector } from "react-redux";
import { getPass, userToken } from "module/passModule";
import { getContract } from "module/contractModule";
import { getChange } from "module/changeCmsModule";

const User = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    // const custId = useSelector(state => state.change?.custId);
    const [phoneNumber] = useState(useSelector(state => state.change?.phoneNumber));
    
    const { data } = useSelector(state => state.contract);
    const token = useSelector(state => state.pass.accessToken);
    const errMsg = useSelector(state => state.user.errMsg);

    // SAVE API
    const [kunner] = useState(useSelector(state => state.change?.kunner))
    const [custnm] = useState(useSelector(state => state.change?.name))
    const [isCompany] = useState(useSelector(state => state.change?.isCompany))
    const [custId] = useState(useSelector(state => state.change?.custId))
    const [acctno] = useState(useSelector(state => state.change?.acctno))
    const [bankcd] = useState(useSelector(state => state.change?.bankcd))
    const estimate = useSelector(state => state.contract.estimate);
    const recordName = useSelector(state => state.ars.recordName);
    const derName = useSelector(state => state.ars.derName);
    
    const [isLoading, setIsloading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [saveModalOpen, setSaveModalOpen] = useState(false);
    const [flag, setFlag] = useState(false);
    const [query, setQuery] = useState(undefined);
    const [temp, setTemp] = useState(false);
    const [loading, setLoading] = useState(false);
    const [btnClick, setBtnClick] = useState(false);
    const [checkBtn, setCheckBtn] = useState(false); // API 호출 중인지 확인

    const script_arr = [
        "/SW/initech/extension/common/exinterface.js",
        "/SW/initech/extension/crosswebex6.js",
        "/SW/initech/extension/common/exinstall.js",
        "/SW/initech/extension/crosswebexInit.js",
        "/SW/initech/extension/cw_web6_adt.js",
        "/SW/initech/extension/common/js/exproto_ext_daemon.js"
    ];

    // 부모창 / 자식창 구분
    React.useEffect(() => {
        if (window.location?.search && window.location?.search !== "") {
            async function setData() {
                let query = {};
                await window.location?.search?.split("&")?.map((str, idx) => {
                    let split = str.split("=");
                    if (idx === 0) {
                        query[split[0].substring(1)] = decodeURIComponent(split[1]);
                    } else {
                        query[split[0]] = decodeURIComponent(split[1]);
                    }
                });
                if (window.opener && !window.opener.closed) {
                    window.opener.postMessage({ query: query, url: window.location.href }, window.location.origin);
                    window.close();
                }
            }
            setData();
        }
    }, []);

    useEffect(() => {
        window.addEventListener("beforeunload", function(e) {
            e.preventDefault();
            e.returnValue = "변경사항은 저장되지 않습니다";
        });
        if (!estimate && !props.location?.state?.estimate) {
            props.history.push("/cms/change/contractnum");
        }
    }, []);

    // 브라우저 뒤로가기 감지
    useEffect(() => {
        let unlisten = history.listen((location) => {
            if (history.action === 'POP') {
                history.push('/cms/change/contractnum');
            }
        });

        return () => {
            unlisten();
        };
    }, [history]);

    useEffect(() => {
        if (isLoading && btnClick) {
            setLoading(false);
            setBtnClick(false);
            setIsloading(false);
            setTemp(false);
            handleSaveData();
        } 
    }, [isLoading]);

    useEffect(() => {
        if (flag && query && !temp) {
            async function func() {
                await setTemp(true);
                await setBtnClick(true);
                dispatch(getPass.get.request(query));
                setIsloading(true);
                setFlag(false);
                setQuery(undefined);
            }
            func();
        }
    }, [flag, query]);

    useEffect(() => {
        if (errMsg === "TIME OVER") {
            setLoading(false);
        }
    }, [errMsg]);

    // SAVE API
    const handleSaveData = async (e) => {
        setCheckBtn(false);
        new Promise(async (resovle, reject) => {
            try {
                let postData = {
                    KUNNR: kunner,
                    custnm: custnm,
                    isCompany: isCompany,
                    bankIdentification: custId,
                    bankCd: bankcd,
                    bankAccount: acctno,
                    I_ETMTSEQ: estimate,
                };

                isCompany? postData.derName = derName : postData.recordName = recordName

                fetch("/api/v1/cms/save", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    },
                    body: JSON.stringify(postData)
                }).then(response => {
                    if (response.status === 200) {
                        return response
                    }
                }).then(res => {
                    if(res) {
                        props.history.push("/cms/change/signstep1", { estimate: estimate });
                    } else {
                        setSaveModalOpen(true)
                    }
                }).catch(err => {
                    reject(err);
                })
            } catch(e) {
                reject(e);
            }
        })
    }

    // PASS || 공동인증서 인증
    const handleBtnCert = async (e) => {
        setCheckBtn(true);
        if (!isCompany) {
            if(!checkBtn) {
                new Promise(async (resolve, reject) => {
                    try {
                        fetch("/api/v1/niceplus/auth", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                state: "newcms",
                                I_ETMTSEQ: estimate,
                                mobTel: phoneNumber,
                            }),
                        }).then(response => {
                            if (response.status === 200) {
                                return response.json();
                            } else {
                                setCheckBtn(false);
                            }
                        }).then(async res => {
                            if (res && res?.message !== "") {
                                openCertWindow(res.message);
                            }
                        }).catch(error => {
                            reject(error);
                        });
                    } catch(e) {
                        reject(e);
                    }
                });
            }
        } else {
            // 법인 고객
            setCheckBtn(false);
            let p1 = new Promise((resolve, reject) => {
                for (let sc_src of script_arr) {
                    let ex6sc = document.querySelector('script[src="' + sc_src + '"]');
                    if (!ex6sc) {
                        let sc = document.createElement("script");
                        sc.setAttribute("src", sc_src);
                        if (sc_src === "/SW/initech/extension/crosswebex6.js") {
                            sc.setAttribute("charset", "UTF-8");
                        }
                        document.body.appendChild(sc);
                    }
                }
                resolve();
            });
            p1.then(() => {
                setTimeout(() => {
                    handleClickCertPopup();
                }, 1200);
            });
        }
    };

    const openCertWindow = async (niceAuthUrl) => {
        let certWindow = window.open(niceAuthUrl, "popupChk", "width=480, height=812, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no")


        // 사용자가 자식창을 닫을 경우
        let g_oInterval = window.setInterval(() => {
            try {
                if(certWindow === null || certWindow.closed) {
                    window.clearInterval(g_oInterval);
                    setCheckBtn(false);
                }
            } catch(e) {
                setCheckBtn(false);
            }
        }, 500)

        await window.addEventListener("message", getMsg, { once : true });
    };

    const getMsg = async (e) => {
        if (e.origin === window.location.origin) {
            if (e.data.query) {
                if (e.data.query["status"] && e.data.query["status"] === "success") {
                    await setFlag(true);
                    await setQuery(e.data.query);
                } else {
                    setCheckBtn(false);
                    setModalOpen(true);
                }
            }
        }
    }
    
    // 공동인증서 인증 API
    const SendForm = (result, postData) => {
        if (result) {
            let postData = {
                juminNO: custId,
                PKCS7SignedData: result,
                chkvid: "1",
                isCms: false,
                isLogin: true,
                I_ETMTSEQ: estimate
            };

            setLoading(true);
            window
                .fetch(`/api/v1/derauth`, {
                    method: "POST",
                    headers: { 
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(postData)
                })
                .then(result => {
                    if (result.status === 200) {
                        return result.json();
                    } else {
                        setLoading(false);
                        setModalOpen(true);
                    }
                }).then(res => {
                    if (res) {
                        setBtnClick(true);
                        // dispatch(getContract.get.request({ estimate, custId, token: res.accessToken }));
                        setIsloading(true)
                        dispatch(userToken.post.request({ accessToken: res.accessToken }));
                    }
                }).catch(err => {
                    setModalOpen(true);
                })
        } else {
            if (window.INI_ALERT) window.INI_ALERT("전자서명에 실패하였습니다.");
            else alert("전자서명에 실패하였습니다.");
        }
    };

    const handleClickCertPopup = () => {
        if (window.INIWEBEX) {
            const signStr = `${estimate}=${custId}`;
            window.INIWEBEX.sign({
                signType: "P7",
                targetType: "data",
                data: signStr,
                form: "",
                processCallback: SendForm,
                isHtml5: true,
                iniCache: true,
                viewType: "NONE",
                vid: true,
            });
        }
    };

    return (
        <>
            {loading && <UploadLoading />}
            <Header onClick={() => props.history.push("/")}/>
            <div className={styles.contentBoardWrap}>
                <div className={styles.contentBoard}>
                    <div className={styles.innerWrap}>
                        <div className={styles.certificationWrap}>
                            <h1>본인인증</h1>
                            <p>롯데오토리스를 이용해주셔서 감사합니다.</p>
                            <p>
                                원활한 서비스 이용을 위하여<br/>
                                본인 인증을 진행해주시기 바랍니다.
                            </p>
                            <Button text={"본인인증"}
                                    style={{margin: "40px 0", backgroundColor: "#DA291C"}}
                                    onClick={handleBtnCert}
                            />
                            <div className={commonStyles.noticeWrap} style={{marginTop: "0"}}>
                                <p>
                                    - 본인인증 절차를 거치지 않으면 서비스를 이용하실 수 없습니다.
                                </p>
                                <p>
                                    - 계약자 본인 명의의 PASS 인증 또는 공인인증서를 통해 본인 인증을 진행해 주시기 바랍니다.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div></div>
            </div>
            <Modal01 open={modalOpen} close={() => setModalOpen(false)} header="본인인증 실패">
                본인인증에 실패하였습니다.<br/>
                잠시 후 다시 시도해주세요.
            </Modal01>
            <Modal01 open={saveModalOpen} close={() => setSaveModalOpen(false)} header="데이터 저장 실패">
                데이터 저장에 실패하였습니다.<br/>
                롯데오토리스 측에 문의해주시길 바랍니다.
            </Modal01>
        </>
    );

};

export default User;